define('taoQtiItem/qtiXmlRenderer/renderers/interactions/HotspotInteraction',['tpl!taoQtiItem/qtiXmlRenderer/tpl/interactions/blockInteraction'], function(tpl){
    return {
        qtiClass : 'hotspotInteraction',
        template : tpl
    };
});
